import * as Mutations from './mutations';
import { ParentsService } from '../../../common/services/pages/parents.service';

export const ParentsModule = {
    state: {
        parents: null
    },

    mutations: {
        [Mutations.SET_PARENTS] (state, parents) {
            state.parents = parents;
        }
    },

    actions: {
        async getParents(context) {
            const { data } = await ParentsService.getParents(context.getters.schoolId);

            context.commit(Mutations.SET_PARENTS, data);
        }
    },

    getters: {
        parentsList: state => state.parents,
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/parents/parents.module.js